// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { environment, region, isAWSDomain } from '@microbt/shared';
      import queryString from 'query-string';
      import { message } from 'antd';
      import { createHistory, history } from 'umi';
      import type { AxiosResponse, RequestConfig, RequestError, RequestOptions } from 'umi';
      
      function baseUrl() {
        const env = environment();
        const country = region();
        const path = "/";
        const name = "api";

        if (env === 'prod') {
          return isAWSDomain() ? `//${name}-${country}-aws.superacme.com${path}` : `//${name}-${country}.superacme.com${path}`;
        }

        if (env === 'dev') {
          if ("undefined" !== 'undefined') {
            return "undefined" +  `${path}`;
          }
          return isAWSDomain() ? `//${name}-${country}-${env}-aws.superacme.com${path}` : `//${name}-${country}-${env}.superacme.com${path}`;
        }

        if (env === 'test') {
          if ("undefined" !== 'undefined') {
            return "undefined" +  `${path}`;
          }
          return isAWSDomain() ? `//${name}-${country}-${env}-aws.superacme.com${path}` : `//${name}-${country}-${env}.superacme.com${path}`;
        }

      
        if (env === 'pre') {
          if ("undefined" !== 'undefined') {
            return "undefined" +  `${path}`;
          }
          return  isAWSDomain() ? `//${name}-${country}-${env}-aws.superacme.com${path}` : `//${name}-${country}-${env}.superacme.com${path}`;
        }

        if (env === 'local') {
          if ("//localhost:8000" !== 'undefined') {
            return "//localhost:8000" +  `${path}`;
          }
          return `//${name}-${country}-dev.superacme.com${path}`;
        }
      
        // local and unknown environment
        return path;
      }
      
      interface Actions {
        onTokenFailed: () => void;
        onAccessDenied: () => void;
        onErrorMessage: (message: string) => void;
        onTipMessage: (message: string) => void;
      }
      
      interface Conditions {
        isTokenFailed: (code: number) => boolean;
        isAccessDenied: (code: number) => boolean;
        isTipMessage: (code: number) => boolean;
      }
      
      // @see http://192.168.9.242:8090/pages/viewpage.action?pageId=11539896
      export const tokenFailed = (code: number): boolean => {
        return code === 1000001 || code === 1000000;
      };
      
      export const accessDenied = (code: number): boolean => {
        return code === 1000002;
      };
      
      export const tipMessage = (code: number): boolean => {
        return code === 1001007;
      };

      export const qiankunHistory = () => {
        // 在宿主环境，需要返回主应用首页，独立运行返回子应用首页
        return window.__POWERED_BY_QIANKUN__ ? createHistory({}) : history;
      };

      type History = ReturnType<typeof createHistory>;
      export const redirectToForbidden = (history: History) => {
        createHistory({}).push('/common/unaccessable');
      };

      export const redirectToLogin = (history: History) => {
        const { search, pathname } = window.location;

        if (window.location.pathname !== '/login') {
          createHistory({}).replace({
            pathname: '/login',
            search: queryString.stringify({
              redirect: pathname + search,
            }),
          });
        }
      };

      export const handleTokenFailed = () => redirectToLogin(qiankunHistory());

      export const handleAccessDenied = () => redirectToForbidden(qiankunHistory());

      export const handleErrorMessage = (msg) => message.error(msg);

      export const handleTipMessage = (msg) => message.info(msg);
      
      export const createErrorConfigs = (
        actions?: Actions,
        conditions?: Conditions,
      ): RequestConfig['errorConfig'] => {
        const { onTokenFailed = handleTokenFailed,  onAccessDenied = handleAccessDenied, onErrorMessage = handleErrorMessage, onTipMessage = handleTipMessage } = actions || {};
        
        return {
          withCredentials: true,
          errorConfig: {
            errorHandler(error: RequestError, options: RequestOptions) {
              const { message } = error;
      
              if (options.skipErrorHandler) {
                return;
              }
      
              const status = error?.response?.status;
      
              if (status === 401) {
                onTokenFailed();
              } else if (status === 403) {
                onAccessDenied();
              } else {
                onErrorMessage(message);
              }
            },
          },
          requestInterceptors: [
            (url: string, options: RequestOptions) => {
              return {
                url,
                options: {
                  ...options,
                  headers: {
                     Authorization: `APPCODE 4733b736ca4a4eaebe4c5578f16a2a1d`,
                    ...options?.headers,
                  },
                },
              };
            },
          ],
          responseInterceptors: [
            (response: AxiosResponse) => {
              const { onTokenFailed = handleTokenFailed,  onAccessDenied = handleAccessDenied, onErrorMessage = handleErrorMessage, onTipMessage = handleTipMessage } = actions || {};
              const { config, data } = response;
              const { skipErrorHandler } = config;
              const { code, message } = data;
      
              const { isAccessDenied = accessDenied, isTipMessage = tipMessage, isTokenFailed = tokenFailed } = conditions || {};
      
              if (skipErrorHandler && code !== 0) {
                return response;
              }
      
              if (isTokenFailed(code)) {
                onTokenFailed();
              } else if (isAccessDenied(code)) {
                onAccessDenied();
              } else if (isTipMessage(code)) {
                onTipMessage(message);
              } else if (code !== 0) {
                onErrorMessage(message);
              }
      
              return response;
            },
          ],
        };
      };

      export const config = {
        baseURL: baseUrl(),
        timeout: 15000,
        ...createErrorConfigs(),
      };
